import { ErrorMessage } from '@hookform/error-message'
import { yupResolver } from '@hookform/resolvers/yup'
import Button from 'components/button'
import OtpInput from 'components/otp-input'
import { useForm } from "react-hook-form";
import formServices from 'services/form-builder-services'
import useRouter from 'hooks/use-router';
import { SubTitleSignUpOtp, TextSignUpOtp } from '../styles/custom.style';

interface IProps {
  email: string;
  handleConfirm: (data: any) => void;
}

function Otp({ email = '', handleConfirm }: IProps) {

  const { handleSubmit, formState: { errors }, setValue } = useForm({ resolver: yupResolver(formServices.formGenerateSchema(["otp"])) })
  const { history } = useRouter()

  const onSubmit = (data) => {
    handleConfirm(data)
  }

  return (
    <section className="flex flex-col flex-1 p-7 md:pt-10">
      <form className="flex h-full justify-between flex-col gap-4" onSubmit={handleSubmit(onSubmit)} noValidate>
        <SubTitleSignUpOtp className="text-center text-lg font-medium saira uppercase">Ingresa el código de 6 dígitos QUE RECIBISTE para verificar tu email.</SubTitleSignUpOtp>
        <div className="flex-1 flex flex-col gap-4">
          <div className="gap-2 flex flex-col">
            <OtpInput setValue={setValue} />
            <ErrorMessage errors={errors} name="otp" />
          </div>
          <div className="flex-1 flex justify-center">
            <div className="h-full flex flex-col justify-center items-center text-center w-4/5">
              <TextSignUpOtp className="my-4">Una contraseña de un solo uso se envió al {email}</TextSignUpOtp>
            </div>
          </div>
        </div>
        <Button>
          <p className="uppercase">Verificar</p>
        </Button>
        <button type="button" className="cursor-pointer">
          <p
            className={`din text-center mt-3 hover:text-red-100 uppercase underline`}
            style={{ fontSize: 10 }}
            onClick={() => {
              history.goBack()
            }}
          >
            VOLVER
          </p>
        </button>
      </form>
    </section>
  )
}

export default Otp